// The theme's dropdown pop, also exposed to CSS as `--ld-motion-dropdown-*`
export const DROPDOWN_DURATION = 160;
export const DROPDOWN_EASING = 'cubic-bezier(0.32, 1.25, 0.6, 1)';
